import styled from 'styled-components';

interface CheckBoxContainerProps {
	gap?: string;
}

export const CheckboxContainer = styled.div<CheckBoxContainerProps>`
	align-items: center;
	cursor: pointer;
	display: flex;
	gap: ${({ gap }) => gap || '10px'};
`;

export const Input = styled.input`
	cursor: pointer;
	height: 16px;
	width: 16px;
`;

interface LabelProps {
	fontSize?: string;
}

export const Label = styled.label<LabelProps>`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: ${({ fontSize }) => fontSize || '14px'};
	line-height: 17px;
	margin-top: 2px;
`;
